import { PrismicRichText } from "@prismicio/react";

export default function StatItem2({ title, subTitle }) {
  return (
    <div className="md:basis-[25%] flex flex-col items-center py-[12px] md:py-0 border-b-[0.5px] md:border-b-0 last:border-b-0 md:last:border-r-0 odd:border-r-[0.5px] md:border-r-[0.5px] border-[#C5C5C5]">
      <div className=" title-font title-2xl text-[#DAA27A]">
        <PrismicRichText field={title} />
      </div>
      <div className="text-medium text-center text-[#232629]">
        <PrismicRichText field={subTitle} />
      </div>
    </div>
  );
}
